import { Swiper } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';
import { SwiperSlide } from 'swiper/react';

import layout from '../../styles/layout.module.css';
import MobileFaceplateSection from './MobileFaceplateSection';

SwiperCore.use([Pagination]);

let MobileFaceplatesList = ({ faceplateOption }) => {
    let render = [];
    Object.keys(faceplateOption).forEach((key) => {
        let container = (
            <SwiperSlide style={{ height: '98%' }} key={key}>
                <MobileFaceplateSection title={key} options={faceplateOption[key]} />
            </SwiperSlide>
        );
        render.push(container);
    });

    return (
        <Swiper
            modules={[Pagination]}
            pagination={true}
            className={layout.containerFull}
            spaceBetween={50}>
            {render}
        </Swiper>
    );
};

export default MobileFaceplatesList;
